import { Injectable } from '@angular/core';
import { NavigationHelper } from '@core/services/core/navigation-helper.service';
import { UiHelperService } from '@core/services/core/ui-helper.service';
import {
  BusinessForwardEmailErrorCodes,
  BusinessLoginUserData
} from '@models/business';

@Injectable({
  providedIn: 'root'
})
export class BusinessesLoginHelperService {
  constructor(private nav: NavigationHelper, private ui: UiHelperService) {}

  async onForwardEmailError(
    errorCode: BusinessForwardEmailErrorCodes,
    userData?: BusinessLoginUserData,
    comesFromUpdatingEmail = false
  ) {
    switch (errorCode) {
      case BusinessForwardEmailErrorCodes.FAILED_EMAIL:
        this.nav.toNew(['businesses', 'email', 'forward', 'result'], {
          state: {
            isSuccess: false,
            comesFromUpdatingEmail,
            userData
          }
        });
        break;
      case BusinessForwardEmailErrorCodes.FAILED_MODIFY:
        this.nav.toNew(['businesses', 'email', 'update', 'result'], {
          state: { isSuccess: false, email: userData?.email }
        });
        break;
      case BusinessForwardEmailErrorCodes.BAD_REQUEST:
      case BusinessForwardEmailErrorCodes.FAILED_REQUEST:
      case BusinessForwardEmailErrorCodes.INTERNAL_ERROR:
      default:
        await this.ui.presentOneButtonAlert({
          image: 'assets/images/result/error.svg',
          title: 'BUSINESSES.KO_UNEXPECTED_ERROR.TITLE',
          description: 'BUSINESSES.KO_UNEXPECTED_ERROR.DESCRIPTION',
          okText: 'UNDERSTOOD',
        });
        break;
    }
  }
}
